/** The user backed out of the provider's popup. Not an error worth surfacing. */
export class SsoCancelledError extends Error {
    constructor() {
        super('SSO_CANCELLED');
    }
}

/** No client id for this provider in this build. */
export class SsoNotConfiguredError extends Error {
    constructor() {
        super('SSO_NOT_CONFIGURED');
    }
}
